import React from 'react';
import bemCn from 'bem-cn';
import SvgDog from 'src/assets/svg/SvgDog.svg';
import './style.scss';

const b = bemCn('designed-for-private-comp');

const DesignedForPrivate = ({ banner = false }) => {
    const title = 'Designed for private play';
    const subtitle = 'Only the people and dogs in your booking are allowed in the spot during your visit.';

    return (
        <div className={b.mix(banner ? 'private-banner' : '')}>
            <SvgDog className={b('icon')} />
            <div className={b('content')}>
                <div className={b('title')}>{`${title}${banner ? '. ' : ''}`}</div>
                <div className={b('subtitle')}>{subtitle}</div>
            </div>
        </div>
    );
};

export default DesignedForPrivate;
